import { useNavigate } from "react-router-dom";
import { Users, MessageSquare, TrendingUp } from "lucide-react";
import { SectionHeading, GoldButton } from "@/components/site/ui";

export function CommunityTeaser() {
    const nav = useNavigate();
    const rooms = ["Startup Growth", "Digital Marketing", "Influencer Marketing", "Business Networking", "PR & Media", "Women in Business", "Founders Club"];
    return (
        <section className="bg-teal-950 py-20 grain" data-testid="community-teaser">
            <div className="container-x grid lg:grid-cols-2 gap-10 items-center">
                <div>
                    <SectionHeading eyebrow="Community" title="The Community Behind the Brands" subtitle="Share wins, ask questions, discover opportunities and connect with founders, creators and marketers." />
                    <div className="flex flex-wrap gap-2 mt-6">{rooms.map((r) => <span key={r} className="card-teal rounded-full px-4 py-2 text-sm text-cream">{r}</span>)}</div>
                    <GoldButton onClick={() => nav("/community")} className="mt-7" data-testid="community-cta">Join the Community</GoldButton>
                </div>
                <div className="grid grid-cols-3 gap-4">
                    {[{ icon: Users, k: "New Members", v: "Daily" }, { icon: MessageSquare, k: "Discussions", v: "Trending" }, { icon: TrendingUp, k: "Creators", v: "Popular" }].map((s) => (
                        <div key={s.k} className="card-teal rounded-2xl p-5 text-center"><s.icon className="w-6 h-6 text-gold mx-auto" /><div className="text-cream font-semibold text-sm mt-2">{s.k}</div><div className="text-xs text-cream-soft/60">{s.v}</div></div>
                    ))}
                </div>
            </div>
        </section>
    );
}
